import ActionButton from '@/components/buttons/ActionButton.tsx';

interface DraftCardActionsProps {
  onApplyPackage: () => void;
  onSaveAndExit: () => void;
  onDiscardDraft: () => void;
}

/** Trzy wyjścia z edycji: wprowadź paczkę, zapisz na później, odrzuć szkic. */
const DraftCardActions = ({
  onApplyPackage,
  onSaveAndExit,
  onDiscardDraft,
}: DraftCardActionsProps) => (
  <div className="flex flex-col gap-2.5 px-5 pb-[18px]">
    <ActionButton
      tone="accent"
      size="md"
      onClick={onApplyPackage}
      className="w-full"
    >
      Wprowadź paczkę →
    </ActionButton>
    <ActionButton
      tone="outline"
      size="md"
      onClick={onSaveAndExit}
      className="w-full"
    >
      Zapisz i wyjdź
    </ActionButton>
    <ActionButton
      tone="dangerGhost"
      size="sm"
      onClick={onDiscardDraft}
      className="w-full"
    >
      Odrzuć szkic
    </ActionButton>
  </div>
);

export default DraftCardActions;
